import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { BrandingProvider } from "@/contexts/BrandingContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Users from "@/pages/Users";
import Branding from "@/pages/Branding";
import Settings from "@/pages/Settings";
import Customers from "@/pages/Customers";
import Reports from "@/pages/Reports";
import Analytics from "@/pages/Analytics";
import Profile from "@/pages/Profile";
import LeadAccessLog from "@/pages/LeadAccessLog";
import "@/App.css";

export default function App() {
  return (
    <ThemeProvider>
      <BrandingProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "hsl(var(--background))",
                  color: "hsl(var(--foreground))",
                  border: "1px solid hsl(var(--border))",
                  borderRadius: "0.25rem",
                },
              }}
            />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/leads" element={<Leads />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/analytics" element={
                  <ProtectedRoute roles={["master_admin"]}><Analytics /></ProtectedRoute>
                } />
                <Route path="/reports" element={
                  <ProtectedRoute roles={["master_admin"]}><Reports /></ProtectedRoute>
                } />
                <Route path="/access-log" element={
                  <ProtectedRoute roles={["master_admin"]}><LeadAccessLog /></ProtectedRoute>
                } />
                <Route path="/users" element={
                  <ProtectedRoute roles={["master_admin", "admin"]}><Users /></ProtectedRoute>
                } />
                <Route path="/branding" element={
                  <ProtectedRoute roles={["master_admin"]}><Branding /></ProtectedRoute>
                } />
                <Route path="/settings" element={
                  <ProtectedRoute roles={["master_admin"]}><Settings /></ProtectedRoute>
                } />
              </Route>
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </BrandingProvider>
    </ThemeProvider>
  );
}
